import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const evalSessionKey = (token) => `plena_eval_session:${token}`;

api.interceptors.request.use((config) => {
  const m = (config.url || "").match(/^\/e\/([^/]+)/);
  if (m) {
    const s = sessionStorage.getItem(evalSessionKey(m[1]));
    if (s) config.headers["X-Eval-Session"] = s;
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const url = orig.url || "";
    if (err.response?.status === 401 && !orig._retry && !url.includes("/auth/") && !url.startsWith("/e/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    throw err;
  }
);

export function errText(e, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.message === "string") return d.message;
  return fallback;
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
